<template>
  <div>
    <ColumnHeader
      title="Varer"
      icon="mdi-truck-delivery-outline"
      :subTitle="getSubtitle"
      :loading="loading"
    >
      <!-- <v-btn
        large
        depressed
        color="primary"
        @click="toggleAllGoodsSelection()"
        v-show="enableActionReceiveGoods()"
        ><v-icon left color="success" class="pa-2">mdi-check</v-icon> Motta
        alle</v-btn
      > -->
      <div v-if="enableActionReceiveGoods()" class="d-flex pt-1 pr-2">
        <div class="text-center pr-2 pt-2">
          <span>{{ selectionText }}</span>
        </div>
        <v-btn
          fab
          small
          :outlined="!selectAllGoods"
          depressed
          hide-details
          :ripple="false"
          color="primary"
          class="pl-2"
          @click="toggleAllGoodsSelection()"
          ><v-icon
            :color="selectAllGoods ? 'success' : 'lightGrey'"
            class="mr-2"
            >mdi-check</v-icon
          ></v-btn
        >
      </div>
    </ColumnHeader>
    <div v-if="!isLoading">
      <v-row
        v-for="(order, index) in orderLines"
        :key="index"
        class="mt-1"
        no-gutters
      >
        <v-col :cols="enableActionReceiveGoods() ? getCaseCardThreshold : '12'">
          <CaseCard
            :class="$vuetify.breakpoint.smAndDown ? 'pa-1' : 'pl-1 py-1'"
            :title="order.componentName"
            removeSideline
            removeArrowIcon
            removeBottom
            @click="openOrderInfo(order)"
          >
            <template v-slot:chips>
              <v-chip
                class="mr-2"
                small
                :color="qtyFullyReceived(order) ? 'success' : 'warning'"
              >
                {{ getOrderQtyReceived(order) }}/{{ getorderQty(order) }}
                {{ order.unit }}
              </v-chip>
            </template>
            <template v-slot:deadline> #{{ order.componentId }} </template>
          </CaseCard>
        </v-col>
        <v-col
          :cols="enableActionReceiveGoods() ? getCasebtnThreshold : '0'"
          class="d-flex justify-end"
        >
          <div v-if="enableActionReceiveGoods() && enableActionOrder(order)">
            <v-btn
              class="mt-2 pa-1"
              fab
              :outlined="!qtyFullyReceived(order)"
              depressed
              x-large
              hide-details
              color="primary"
              @click="activateFullyReceived(order)"
            >
              <v-icon v-if="qtyFullyReceived(order)" color="success">
                mdi-check
              </v-icon>
              <v-icon
                v-if="
                  !qtyFullyReceived(order) &&
                  order.qtyReceived &&
                  order.qtyReceived > 0
                "
                color="warning"
              >
                mdi-alert-circle-check-outline
              </v-icon>
              <v-icon
                v-if="
                  !qtyFullyReceived(order) &&
                  (!order.qtyReceived || order.qtyReceived === 0)
                "
                color="lightGrey"
              >
                mdi-check
              </v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-row v-if="isLoading" class="mt-3">
        <v-col v-for="index in 4" :key="index" sm="12">
          <CaseCard
            :loading="true"
            removeSideline
            removeArrowIcon
            removeBottom
          />
        </v-col>
      </v-row>
    </div>

    <div class="text-center pr-2">
      <v-btn
        v-if="!$vuetify.breakpoint.smAndDown && enableActionReceiveGoods()"
        depressed
        large
        block
        color="primary"
        class="mb-4 mt-4"
        :disabled="
          !getActivateReceivedGoods ||
          allGoodsReceived ||
          !enableActionReceiveGoods()
        "
        @click.once="receiveOrderGoods()"
      >
        <v-icon left large color="success" class="pr-4">mdi-check</v-icon>
        Bekreft varemottak
      </v-btn>
    </div>

    <OrderInfoDialog
      v-model="getShowDialog"
      :order="orderInfo"
      :orderAlreadyReceived="
        orderInfo.qtyAlreadyReceived
          ? Number(orderInfo.qtyAlreadyReceived) === Number(orderInfo.qty)
          : false
      "
      :goodsNotReceived="goodsNotReceived"
      :actionEnable="enableActionReceiveGoods()"
      @updateOrderInfo="updateOrderInfo"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { OrderLines } from "@/types/orderInterface";
import ColumnHeader from "@/components/shared/ColumnHeader.vue";
import CaseCard from "@/components/shared/cards/CaseCard.vue";
import OrderInfoDialog from "@/components/projects/project/house/orders/order/children/OrderInfoDialog.vue";
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";

export default Vue.extend({
  name: "OrderList",
  props: {
    value: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    lines: {
      type: Array,
      default: null,
    },
    activateReceivedGoods: {
      type: Boolean,
      default: false,
    },
    enableActions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showConfirmLeavingReceiveOrder: false,
      showFullyReceiveDialog: false,
      selectAllGoods: false,
      selectionText: "Sett fullt varemottak på alle linjer",
      enableReceiveGoodsBtn: false,
      allGoodsReceived: false,
      receivedGoodsCount: 0,
      openDialog: false,
      isLoading: false,
      orderInfo: {} as OrderLines,
      fullyReceived: false,
      goodsNotReceived: true,
    };
  },
  created() {
    this.isLoading = this.loading;
    this.SetShowConfirmMessage(false);
    this.enableReceiveGoodsBtn = false;
    this.setAllGoodsReceivedStatus();
  },
  methods: {
    ...mapActions({ SetShowConfirmMessage: "shared/SetShowConfirmMessage" }),
    openOrderInfo(order: OrderLines) {
      this.orderInfo = JSON.parse(
        JSON.stringify(
          this.orderLines.filter(
            (o: OrderLines) => o.componentId === order.componentId
          )[0] as OrderLines
        )
      );
      this.openDialog = true;
      if (this.enableActionReceiveGoods()) {
        this.SetShowConfirmMessage(true);
      }
      this.getActivateReceivedGoods = true;
    },
    enableActionOrder(order: OrderLines): boolean {
      if (!order.qtyAlreadyReceived || order.qtyAlreadyReceived === 0) {
        return true;
      }
      return Number(order.qtyAlreadyReceived) !== Number(order.qty);
    },
    enableActionReceiveGoods(): boolean {
      if (this.value.allReceived) {
        this.goodsNotReceived = this.value.allReceived ? false : true;
      } else if (this.value.orderLines) {
        this.goodsNotReceived = (this.lines as Array<OrderLines>).find(
          (x) => Number(x.qty) !== Number(x.qtyAlreadyReceived)
        )
          ? true
          : false;
      }

      let enableActions =
        this.value.status === "Frigitt" && this.goodsNotReceived;
      this.$emit("update:enableActions", enableActions);
      return enableActions;
    },
    isQtyFullyReceive(order: OrderLines): boolean {
      return order.qty &&
        order.qtyAlreadyReceived &&
        order.qty === order.qtyAlreadyReceived
        ? true
        : false;
    },
    setAllGoodsReceivedStatus() {
      if (this.lines) {
        this.allGoodsReceived = (this.lines as Array<OrderLines>).find(
          (x) => x.qty !== x.qtyAlreadyReceived
        )
          ? false
          : true;

        this.receivedGoodsCount = (this.lines as Array<OrderLines>).filter(
          (x) => x.qty === x.qtyAlreadyReceived
        )?.length;

        this.lines.forEach((o) => {
          (o as OrderLines).orderQtyChanged = false;
        });
      }
    },
    async toggleAllGoodsSelection() {
      this.selectAllGoods = !this.selectAllGoods;
      this.selectionText = this.selectAllGoods
        ? "Sett fullt varemottak på alle linjer"
        : "Fjern fullt varemottak på alle linjer";

      this.fullyReceived = this.selectAllGoods;
      this.getActivateReceivedGoods = this.selectAllGoods;
      if (this.enableActionReceiveGoods()) {
        this.SetShowConfirmMessage(true);
      }

      this.$emit("updateAllAllGoodsFullyReceive", this.selectAllGoods);
    },
    async receiveOrderGoods() {
      this.isLoading = true;
      this.$emit("receiveOrderGoods", true);
    },
    qtyFullyReceived(order: OrderLines): boolean {
      switch (order.receivedGoodsAction) {
        case 0:
          return true; //fullmottak
        case 1:
          return true; //Korriger bestilling
        case 2:
          return false; //delmottak
        default:
          if (
            order.qtyAlreadyReceived &&
            Number(order.qty) === Number(order.qtyAlreadyReceived)
          ) {
            return true;
          }

          if (
            order.qtyReceived &&
            Number(order.qtyReceived) -
              (order.qtyAlreadyReceived
                ? Number(order.qtyAlreadyReceived)
                : 0) ===
              Number(order.qty)
          ) {
            return true;
          }
          return false;
      }
    },
    activateFullyReceived(order: OrderLines) {
      this.fullyReceived = order.qtyReceived
        ? Number(order.qty) !=
          Number(order.qtyReceived) +
            (order.qtyAlreadyReceived ? Number(order.qtyAlreadyReceived) : 0)
        : true;
      this.$emit("updateOrderFullyReceive", order, this.fullyReceived);

      const line = this.orderLines.filter(
        (o: OrderLines) => o.componentId === order.componentId
      )[0] as OrderLines;

      this.orderInfo = JSON.parse(JSON.stringify(line));
      order = JSON.parse(JSON.stringify(line));
      this.getActivateReceivedGoods = true;

      if (this.enableActionReceiveGoods()) {
        this.SetShowConfirmMessage(true);
      }
    },
    updateOrderInfo(orderId: number, textQty: string, selectedAction: number) {
      switch (selectedAction) {
        case 0: //full mottak
          this.orderInfo.receivedGoodsAction = selectedAction;
          this.orderInfo.qtyReceived =
            Number(textQty) -
            (this.orderInfo.qtyAlreadyReceived
              ? this.orderInfo.qtyAlreadyReceived
              : 0);
          break;
        case 1: //Korriger ant. i bestilling
          this.orderInfo.receivedGoodsAction = selectedAction;
          this.orderInfo.qtyReceived = Number(textQty);
          break;
        case 2: //rapporter delmottak
          this.orderInfo.receivedGoodsAction = selectedAction;
          this.orderInfo.qtyReceived =
            Number(textQty) -
            (this.orderInfo.qtyAlreadyReceived
              ? (this.orderInfo.qtyAlreadyReceived as number)
              : 0);
          break;
      }
      this.$emit("updateOrderInfo", this.orderInfo);
    },
    getOrderQtyDisplayText(data: number): string {
      if (!data) {
        return "0";
      }
      if (data % 1 === 0) {
        return data.toString();
      } else {
        return data.toFixed(2);
      }
    },
    // getTransitionBtnOnScroll() {
    //   window.onscroll = () => {
    //     setTimeout(() => {
    //       this.showTransitionBtn = true;
    //     }, 2000);
    //   };
    // },
    // getOrderQtyAlreadyReceived(): number {
    //   return this.orderInfo.qtyAlreadyReceived
    //     ? this.orderInfo.qtyAlreadyReceived
    //     : 0;
    // },
    getOrderQtyReceived(data: OrderLines): string {
      // if (data.qtyAlreadyReceived && !data.qtyReceived) {
      //   return this.getOrderQtyDisplayText(Number(data.qtyAlreadyReceived));
      // }
      // return this.getOrderQtyDisplayText(Number(data.qtyReceived));
      let received = data.qtyReceived
        ? Number(data.qtyReceived) + Number(data.qtyAlreadyReceived)
        : Number(data.qtyAlreadyReceived);
      return this.getOrderQtyDisplayText(received);
    },
    getorderQty(data: OrderLines): string {
      return this.getOrderQtyDisplayText(Number(data.qty));
    },
  },
  computed: {
    ...mapGetters({ showConfirmMessage: "shared/showConfirmMessage" }),
    orderLines(): Array<OrderLines> {
      return this.value.orderLines;
    },
    showReceiveGoodButton(): boolean {
      if (process.env.NODE_ENV === "production") {
        return false;
      } else {
        return true;
      }
    },
    getShowDialog: {
      get(): boolean {
        return this.openDialog;
      },
      set(value: boolean) {
        this.openDialog = value;
      },
    },
    getSubtitle(): string {
      if (this.receivedGoodsCount === 0) {
        this.setAllGoodsReceivedStatus();
      }
      return this.receivedGoodsCount + "/" + this.lines?.length + " mottatt";
    },
    getActivateReceivedGoods: {
      get(): boolean {
        return this.activateReceivedGoods;
      },
      set(data: boolean) {
        this.enableReceiveGoodsBtn = data && this.enableActionReceiveGoods();
        this.$emit("update:activateReceivedGoods", this.enableReceiveGoodsBtn);
      },
    },
    getCaseCardThreshold(): number {
      if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) {
        return 9;
      } else if (
        this.$vuetify.breakpoint.md ||
        this.$vuetify.breakpoint.lgAndUp
      ) {
        return 10;
      }
      return 9;
    },
    getCasebtnThreshold(): number {
      if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) {
        return 3;
      } else if (
        this.$vuetify.breakpoint.md ||
        this.$vuetify.breakpoint.lgAndUp
      ) {
        return 2;
      }
      return 3;
    },
  },
  components: {
    ColumnHeader,
    CaseCard,
    OrderInfoDialog,
  },
});
</script>

<style lang="scss" scoped>
.bottomTransitonBtn {
  z-index: 3;
  left: 50%;
  transform: translate(-50%, -50%);
  bottom: calc(65px + env(safe-area-inset-bottom, 65px));
}

ptrBtn {
  pointer-events: none;
}

// div#infoChips {
//   padding: 2px;
//   margin: 2px;
//   background-color: "#b4b4b4";
//   border-radius: 12px;
//   //width: 300px;
// }
</style>
